// extracted by mini-css-extract-plugin
module.exports = {"ho87ukn":"ho87ukn"};